import { post } from '@/utils/http'

const state = {
  isFirstAccess: false
}

const getters = {
}

const mutations = {
  SET_READ_AGREEMENT (state, payload) {
    state.isFirstAccess = payload
  }
}

const setStorageFirstAgreement = (resolve, commit, value = false) => {
  resolve(value)
  commit('SET_READ_AGREEMENT', value)
  sessionStorage.setItem('FirstAccessWx', 0) // 不是首次访问
}

const actions = {
  getReadAgreements ({ commit }) {
    return new Promise((resolve) => {
      post('/banner/firstAgreement', {}).then(res => {
        if (res.respCode === 1001 && res.data.result === 1) {
          commit('SET_READ_AGREEMENT', true)
          resolve(true)
        } else { // 不是首次访问
          setStorageFirstAgreement(resolve, commit)
        }
      }).catch(() => { // 不是首次访问
        setStorageFirstAgreement(resolve, commit)
      })
    })
  },
  updateFisrtReadAgreeStatus ({ commit }) {
    return new Promise((resolve) => {
      post('/banner/addFirstAgreement', {}).then(res => {
        commit('SET_READ_AGREEMENT', false)
        sessionStorage.setItem('FirstAccessWx', 0) // 不是首次访问
        resolve(false)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement.js